import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from '~shared/components/react/LoadingIndicator';
import { generateBetGeniusEventHandler } from '../handlers/betGeniusStreamingHandler';
import './styles/betGeniusStreaming.scss';

const BetGeniusStreaming = ({ updateStatus, widgetLoaderScript, eventId }) => {
    const ref = useRef();

    useEffect(() => {
        const eventHandler = generateBetGeniusEventHandler(updateStatus, eventId);

        window.addEventListener('geniussportsmessagebus', eventHandler);

        return () => {
            window.removeEventListener('geniussportsmessagebus', eventHandler);
            /**
             * Please be aware. For the GeniusLivePlayer there can only be one player loaded at a time.
             * It loads a global singleton 'GeniusLivePlayer' object which has an attribute 'player'.
             * When a new player in instantiated that becomes the 'player'.
             * If you instantiate a new player without calling close the current player it will
             * remain in memory and continute to buffer.
             */
            if (window.GeniusLivePlayer?.player) {
                /**
                 * setTimeout 0 prevents from Spectate Client crash caused by Genius Player.
                 * It runs asynchronously with the minimum delay
                 */
                setTimeout(window.GeniusLivePlayer.player.close, 0);
            }
        };
    }, []);

    useEffect(() => {
        const { current: domElement } = ref;

        if (domElement && widgetLoaderScript) {
            const script = document.createElement('script');
            script.text = widgetLoaderScript;
            domElement.appendChild(script);
        }
    }, [widgetLoaderScript]);

    return (
        <div id='geniusLive' className='bg-streaming-player' ref={ref}>
            <LoadingSpinner />
        </div>
    );
};

BetGeniusStreaming.propTypes = {
    widgetLoaderScript: PropTypes.string,
    updateStatus: PropTypes.func,
    eventId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
};

export default BetGeniusStreaming;
